var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164.074,
    height: 186.136,
    viewBox: "0 0 164.074 186.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13417",
    "data-name": "Group 13417",
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6021",
    "data-name": "Group 6021",
    transform: "translate(0 22.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13357",
    "data-name": "Path 13357",
    d: "M-607.743-346.871a82.135,82.135,0,0,1-82.037-82.042,82.134,82.134,0,0,1,82.037-82.037,82.13,82.13,0,0,1,82.037,82.037A82.131,82.131,0,0,1-607.743-346.871Zm0-153.7A71.737,71.737,0,0,0-679.4-428.912a71.738,71.738,0,0,0,71.658,71.662,71.737,71.737,0,0,0,71.657-71.662A71.737,71.737,0,0,0-607.743-500.57Z",
    transform: "translate(689.781 510.949)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6022",
    "data-name": "Group 6022",
    transform: "translate(24.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13358",
    "data-name": "Path 13358",
    d: "M-635.148-400.861a5.1,5.1,0,0,1-1.753-.311,5.168,5.168,0,0,1-3.016-2.834l-44.661-103.952a5.191,5.191,0,0,1,2.719-6.819,5.191,5.191,0,0,1,6.814,2.725l42.472,98.846,42.85-22.014a5.189,5.189,0,0,1,6.99,2.247,5.181,5.181,0,0,1-2.247,6.985l-47.8,24.552A5.221,5.221,0,0,1-635.148-400.861Z",
    transform: "translate(685.002 515.2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.bf09bd58753a4cab7396900722469f3e.svg";
export { ForwardRef as ReactComponent };